export const TWO_FA_TYPES = {
  GOOGLE_AUTHENTICATOR: 'googleAuthenticator',
  EMAIL: 'email',
};

export const TWO_FA_ACTIONS = {
  LOGIN: 'login',
  TURN_OFF_TWO_FA: 'turnOffTwoFa',
};
